// extracted by mini-css-extract-plugin
export default {"Root":"Schedule_Root__kfFRX","Title":"Schedule_Title__KdtFX","Days":"Schedule_Days__eR6gg"};